let currentAnimationFps: number | null = null;
let animationPlaying = false;
let animationSliderScrubbing = false;

export function setCurrentAnimationFps(fps: number | null) {
  currentAnimationFps = fps;
}

export function getCurrentAnimationFps() {
  return currentAnimationFps;
}

export function setAnimationPlaying(playing: boolean) {
  animationPlaying = playing;
}

export function isAnimationPlaying() {
  return animationPlaying;
}

export function setAnimationSliderScrubbing(scrubbing: boolean) {
  animationSliderScrubbing = scrubbing;
}

export function isAnimationSliderScrubbing() {
  return animationSliderScrubbing;
}
